<script setup lang="ts">
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const title = t("legalPages.familyCard.title");
const description = t("legalPages.familyCard.description");
</script>

<template>
  <Title>{{ title }}</Title>
  <Meta name="description" :content="description" />
  <div class="landing">
    <div class="container">
      <h1>Regulamento do Family Club</h1>

      <div class="section">
        <div class="section-title">
          <span class="section-number">1</span>
          Objetivo
        </div>
        <div class="section-content">
          <p>
            O Club de Fidelidade Family Club da Toys"R"Us e Prénatal tem como
            propósito reconhecer e premiar a tua preferência, oferecendo-te
            benefícios exclusivos, promoções especiais e experiências únicas
            pela tua lealdade e constância na compra dos nossos produtos e
            serviços.
          </p>
          <div class="highlight">
            O cartão Family Card é propriedade exclusiva da PRG RETAIL GROUP
            PORTUGAL L.D.A
          </div>
        </div>
      </div>

      <div class="section">
        <div class="section-title">
          <span class="section-number">2</span>
          Definições
        </div>
        <div class="section-content">
          <p>
            <strong>Sócio:</strong> Pessoa física maior de 18 anos que se
            inscreveu corretamente no Club de Fidelidade.
          </p>
          <p>
            <strong>Benefícios:</strong> Produtos, serviços, descontos,
            experiências ou outros prémios oferecidos aos sócios.
          </p>
          <p>
            <strong>Conta:</strong> Registo individual de cada sócio onde se
            refletem os seus pontos e movimentos.
          </p>
        </div>
      </div>

      <div class="section">
        <div class="section-title">
          <span class="section-number">3</span>
          Adesão
        </div>
        <div class="section-content">
          <p>A adesão é <strong>gratuita e voluntária</strong>.</p>
          <p>
            Para te inscreveres, deves completar o formulário de inscrição na
            loja física, site ou aplicação móvel, fornecendo dados pessoais
            verdadeiros e atualizados.
          </p>
          <p>
            A empresa reserva-se o direito de aceitar ou rejeitar pedidos de
            adesão sem necessidade de justificação.
          </p>
          <p>
            Cada pessoa só poderá ter uma conta ativa. Em caso de detetar
            duplicidade, proceder-se-á à unificação das contas.
          </p>
        </div>
      </div>

      <div class="section">
        <div class="section-title">
          <span class="section-number">6</span>
          Troca de Benefícios
        </div>
        <div class="section-content">
          <p>
            Os descontos, cupões ou bónus poderão ser trocados pelos benefícios
            disponíveis e vigentes para os membros do Club, sujeito a
            disponibilidade e condições específicas de cada desconto, bónus ou
            promoção.
          </p>
          <p>
            A lista de benefícios poderá ser modificada periodicamente, sem
            aviso prévio. A qualquer momento, serás informado sobre as
            alterações realizadas através das nossas vias habituais de
            comunicação: página web familycard.es, email ou loja física.
          </p>
          <div class="highlight">
            A troca de descontos, cupões ou bónus é pessoal e intransmissível.
          </div>
        </div>
      </div>

      <div class="section">
        <div class="section-title">
          <span class="section-number">7</span>
          Vigência
        </div>
        <div class="section-content">
          <p>
            Em caso de cancelamento da subscrição, os descontos, cupões ou bónus
            acumulados perder-se-ão de forma definitiva.
          </p>
        </div>
      </div>

      <div class="section">
        <div class="section-title">
          <span class="section-number">8</span>
          Responsabilidades e Obrigações do Sócio
        </div>
        <div class="section-content">
          <ul>
            <li>Manteres atualizados os teus dados pessoais e de contacto.</li>
            <li>Fazeres uso correto e pessoal da adesão.</li>
            <li>
              Notificares imediatamente qualquer uso não autorizado ou suspeita
              de fraude na tua conta.
            </li>
            <li>
              Respeitares os termos e condições do Family Club, assim como as
              políticas da empresa.
            </li>
          </ul>
        </div>
      </div>

      <div class="section">
        <div class="section-title">
          <span class="section-number">9</span>
          Suspensão e Cancelamento da Adesão
        </div>
        <div class="section-content">
          <p>
            A empresa poderá suspender ou cancelar a adesão de qualquer sócio em
            caso de:
          </p>
          <ul>
            <li>Uso indevido ou fraudulento do programa.</li>
            <li>Fornecer informação falsa ou incompleta.</li>
            <li>
              Incumprimento deste regulamento ou das políticas da empresa.
            </li>
          </ul>
          <p>
            Em caso de suspensão ou cancelamento, os descontos, cupões ou bónus
            serão cancelados e não poderão ser reclamados.
          </p>
          <p>
            Em caso de roubo ou extravio do cartão, deverás comunicá-lo
            imediatamente à PRG RETAIL GROUP PORTUGAL L.D.A, dirigindo-te a
            qualquer loja Toys"R"Us ou Prénatal ou por escrito para:
          </p>
          <div class="contact-info">
            <strong>PRG RETAIL GROUP PORTUGAL L.D.A</strong><br />
            Avenida de Aragón 402, Edificio Allende, 6º andar<br />
            28022 Madrid
          </div>
        </div>
      </div>

      <div class="section">
        <div class="section-title">
          <span class="section-number">10</span>
          Modificações ao Regulamento
        </div>
        <div class="section-content">
          <p>
            A empresa reserva-se o direito de modificar, suspender ou cancelar o
            Family Club, os seus benefícios, mecânicas e este regulamento a
            qualquer momento. Qualquer uma das informações anteriores será
            devidamente comunicada aos clientes com as medidas adotadas.
          </p>
          <p>
            Qualquer alteração será comunicada aos sócios através dos canais
            oficiais (correio eletrónico, página web, redes sociais, etc.).
          </p>
          <p>
            A participação contínua no Family Club implica a aceitação das
            modificações realizadas.
          </p>
        </div>
      </div>

      <div class="section">
        <div class="section-title">
          <span class="section-number">11</span>
          Proteção de Dados Pessoais
        </div>
        <div class="section-content">
          <p>
            Os teus dados pessoais fornecidos serão tratados conforme a
            legislação vigente em matéria de proteção de dados e unicamente para
            os fins relacionados com o Family Club.
          </p>
          <p>
            Poderás exercer os teus direitos de informação, acesso, retificação,
            oposição, cancelamento, supressão, limitação de tratamento e/ou
            portabilidade enviando uma solicitação para o endereço de contacto
            indicado pela empresa: <strong>rgpd@toysrus.es</strong>
          </p>
        </div>
      </div>

      <div class="section">
        <div class="section-title">
          <span class="section-number">12</span>
          Contacto e Atendimento aos Sócios
        </div>
        <div class="section-content">
          <p>
            Para qualquer dúvida, esclarecimento ou reclamação, poderás
            comunicar com o centro de atendimento ao cliente, disponível nos
            canais oficiais da empresa.
          </p>
          <p>
            O horário de atendimento e os meios de contacto estarão disponíveis
            na página web e nos estabelecimentos participantes.
          </p>
        </div>
      </div>

      <div class="section">
        <div class="section-title">
          <span class="section-number">13</span>
          Aceitação de Termos
        </div>
        <div class="section-content">
          <p>
            A tua inscrição e participação no Family Club implica a aceitação
            total deste regulamento, das suas normas e das políticas da PRG
            RETAIL GROUP PORTUGAL L.D.A
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.landing body {
  font-family: "Segoe UI", Arial, sans-serif;
  background: #f7f7fa;
  margin: 0;
  padding: 0;
  color: #222;
  line-height: 1.6;
}
.landing .container {
  max-width: 800px;
  margin: 40px auto;
  background: fff;
  border-radius: 14px;
  box-shadow: 0 4px 24px rgba(100, 92, 140, 0.08);
  padding: 40px 32px;
}
.landing h1 {
  color: rgb(100 92 140);
  font-size: 2.5rem;
  font-weight: 800;
  text-align: center;
  margin-bottom: 40px;
  border-bottom: 3px solid rgb(100 92 140);
  padding-bottom: 20px;
}
.landing .section {
  margin-bottom: 32px;
  background: #edeaf6;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(100, 92, 140, 0.06);
}
.landing .section-title {
  color: rgb(100 92 140);
  font-size: 1.4rem;
  font-weight: 700;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
}
.landing .section-number {
  background: rgb(100 92 140);
  color: white;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  margin-right: 12px;
  font-size: 1rem;
}
.landing .section-content {
  font-size: 1.05rem;
  color: #333;
  line-height: 1.7;
}
.landing .section-content p {
  margin-bottom: 12px;
}
.landing .section-content ul {
  margin: 12px 0;
  padding-left: 20px;
}
.landing .section-content li {
  margin-bottom: 8px;
}
.landing .highlight {
  background: rgba(100, 92, 140, 0.1);
  padding: 16px;
  border-left: 4px solid rgb(100 92 140);
  border-radius: 6px;
  margin: 16px 0;
}
.landing .contact-info {
  background: rgb(100 92 140);
  color: white;
  padding: 16px;
  border-radius: 8px;
  margin: 16px 0;
}
@media (max-width: 600px) {
  .landing .container {
    padding: 24px 20px;
    margin: 20px 16px;
  }
  .landing h1 {
    font-size: 2rem;
  }
  .section-title {
    font-size: 1.2rem;
  }
  .section {
    padding: 20px;
  }
}
</style>
